import React from 'react';
import { FeatherIcon } from 'lucide-react';
const coverage = [{
  label: 'Groups',
  body: 'Club, school PE, rec and junior sessions'
}, {
  label: 'Session flow',
  body: 'Warm-up game → skill block → applied game'
}, {
  label: 'Season path',
  body: 'Grip & serve → backcourt → frontcourt → movement → doubles → match play'
}, {
  label: 'Levels',
  body: 'Beginner to intermediate, with a 3-Level Dial in every drill'
}, {
  label: 'Coaching tools',
  body: 'Cue scripts, watch-fors, fixes, easier and harder versions'
}, {
  label: 'Formats',
  body: 'Printable session sheets, drill cards and 20 worksheets'
}];
const dial = [{
  level: 'L1',
  name: 'Beginner',
  body: 'A simpler version so new players succeed',
  feathers: 1
}, {
  level: 'L2',
  name: 'Developing',
  body: 'A step up for players finding their feet',
  feathers: 2
}, {
  level: 'L3',
  name: 'Advanced',
  body: 'A harder twist that keeps your strongest players working',
  feathers: 3
}];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="w-full border-y-4 border-shuttle bg-court" data-id="element-257" data-mp="1b1qwc2makyt0">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-258" data-mp="1f181sw1pxvy6">
        <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-shuttle" data-id="element-259" data-mp="1jszjsi6t6tcp">
          The mechanism
        </p>
        <h2 id="mechanism-heading" className="mt-3 font-display font-bold text-white text-[28px] leading-tight tracking-tight sm:text-5xl" data-id="element-260" data-mp="1or139485cuop">
          The Court-Ready Progression Ladder™
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base sm:text-lg text-white/85" data-id="element-261" data-mp="w5rfo3l49qc9">
          A full season of badminton sessions, written and sequenced. Each one
          is a warm-up game, a skill block and an applied game, and the blocks
          chain into a real progression from first grip to match play. You open
          the day&apos;s session and coach it.
        </p>

        <div className="mt-8 grid gap-2.5 sm:grid-cols-3" data-id="element-262" data-mp="2hfgdzek8wqu8">
          {dial.map(d => <div key={d.level} className="rounded-xl bg-white px-4 py-4 text-left shadow-card" data-id="element-263" data-mp="1rrkq092svpo9">
              <div className="flex items-center justify-between" data-id="element-264" data-mp="1mszom6btazy8">
                <span className="font-display text-lg font-extrabold text-ink" data-id="element-265" data-mp="21rle08bm6tys">
                  {d.level} · {d.name}
                </span>
                <span className="flex gap-0.5" aria-label={`${d.feathers} feather${d.feathers > 1 ? 's' : ''}`} data-id="element-266" data-mp="1wsi68g4929n4">
                  {Array.from({
                length: d.feathers
              }).map((_, i) => <FeatherIcon key={i} className="h-4 w-4 text-green" aria-hidden="true" data-id="element-267" data-mp="144mdfmhsx1vm" data-mpi={i} />)}
                </span>
              </div>
              <p className="mt-1 text-sm text-ink-soft" data-id="element-268" data-mp="1e1hby5e2r29w">{d.body}</p>
            </div>)}
        </div>
        <p className="mt-3 text-[13px] font-semibold text-white/80" data-id="element-269" data-mp="qbn0ns9ellrr">
          The 3-Level Dial: one plan, every player on the right level.
        </p>

        <ul className="mt-8 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-270" data-mp="lcjshyy4mzfk">
          {coverage.map(item => <li key={item.label} className="rounded-lg border border-white/20 bg-white/10 px-4 py-3" data-id="element-271" data-mp="2wyc6l8pbkif7">
              <span className="block text-[11px] font-bold uppercase tracking-widest text-shuttle" data-id="element-272" data-mp="2n2r3164lra3c">
                {item.label}
              </span>
              <span className="mt-1 block text-sm text-white" data-id="element-273" data-mp="2rypux3p53a8i">{item.body}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}